import React, { Component } from "react";
import { getAlertsForKiosk } from "../lib/dataQueries";

import AlertListField from "../components/alertListField";

class AlertListFieldContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alerts: null,
    };
  }

  async componentWillMount() {
    const { record } = this.props;

    try {
      const alerts = await getAlertsForKiosk(record.id);
      if (alerts) {
        this.setState({
          alerts,
        });
      } else {
        console.warn("No alerts returned");
      }
    } catch (e) {
      console.error("Error getting alerts", e);
    }
  }

  render() {
    const { alerts } = this.state;

    return <AlertListField alerts={alerts} />;
  }
}

AlertListFieldContainer.defaultProps = { addLabel: true };

export default AlertListFieldContainer;



// WEBPACK FOOTER //
// ./src/containers/alertListField.js